import React from "react";
import { NavLink } from "react-router-dom";
import { PAGE_MAIN, PAGE_TASK } from "../../shared/constants/constants";
import styles from "./Header.module.css";

export default function Header() {
  return (
    <header className={styles.header}>
      <nav className={styles.header_nav}>
        <NavLink to={PAGE_MAIN} className={styles.header_nav__link}>
          <svg
            className={styles.header_logo}
            width="123"
            height="41"
            viewBox="-2 -2 123 41"
            id="logo-diagnostic-small"
            x="334"
            y="196"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="none" fillRule="evenodd">
              <path
                d="M30.726 5.086A18.12 18.12 0 0023.468.952a29.14 29.14 0 013.635 6.415c1.082-.93 2.3-1.701 3.623-2.281m-7.258 30.852a18.1 18.1 0 007.258-4.132 14.557 14.557 0 01-3.623-2.282 29.12 29.12 0 01-3.635 6.414"
                fill="#E77F75"
              />
              <path
                d="M29.277 18.447c0 3.92-.774 7.661-2.174 11.077 1.082.93 2.3 1.7 3.623 2.282a18.237 18.237 0 004.365-6.216 7.286 7.286 0 01-5.814-7.143m0 0a7.284 7.284 0 015.814-7.144 18.22 18.22 0 00-4.365-6.217 14.492 14.492 0 00-3.623 2.28 29.162 29.162 0 012.174 11.08"
                fill="#EC9867"
              />
              <path
                d="M29.277 18.447a7.286 7.286 0 005.814 7.143 18.224 18.224 0 001.45-7.143c0-2.537-.518-4.951-1.45-7.144a7.284 7.284 0 00-5.814 7.144"
                fill="#F1AA59"
              />
              <path
                d="M23.465 35.94a21.96 21.96 0 01-5.083-5.41 21.974 21.974 0 01-5.084 5.41 18.105 18.105 0 0010.167 0M18.382 6.36A21.96 21.96 0 0123.464.952a18.087 18.087 0 00-10.165 0 21.965 21.965 0 015.083 5.408"
                fill="#E25D75"
              />
              <path
                d="M18.382 6.36a21.817 21.817 0 013.63 12.087 14.56 14.56 0 015.091-11.08A29.113 29.113 0 0023.468.952h-.004a21.96 21.96 0 00-5.082 5.408m3.63 12.087a21.81 21.81 0 01-3.63 12.083 21.975 21.975 0 005.082 5.41l.004-.002a29.12 29.12 0 003.635-6.414 14.56 14.56 0 01-5.09-11.077"
                fill="#E46A66"
              />
              <path
                d="M27.103 29.524a29.163 29.163 0 002.174-11.077 29.17 29.17 0 00-2.174-11.08 14.561 14.561 0 00-5.09 11.08 14.56 14.56 0 005.09 11.077"
                fill="#E77D68"
              />
              <path
                d="M13.293.952a18.104 18.104 0 00-7.255 4.134c1.321.58 2.54 1.352 3.62 2.28A29.139 29.139 0 0113.293.953M6.038 31.806a18.085 18.085 0 007.255 4.132 29.203 29.203 0 01-3.634-6.414c-1.082.93-2.3 1.7-3.621 2.282"
                fill="#B75381"
              />
              <path
                d="M18.382 30.53a21.79 21.79 0 01-3.632-12.083c0-4.471 1.337-8.624 3.632-12.087A21.973 21.973 0 0013.3.952h-.006a29.139 29.139 0 00-3.635 6.415 14.56 14.56 0 015.092 11.08 14.56 14.56 0 01-5.092 11.077 29.19 29.19 0 003.635 6.414l.006.002a21.98 21.98 0 005.083-5.41"
                fill="#C04672"
              />
              <path
                d="M18.382 6.36a21.798 21.798 0 00-3.632 12.087 21.79 21.79 0 003.632 12.083 21.81 21.81 0 003.63-12.083c0-4.471-1.337-8.624-3.63-12.087"
                fill="#DE4A6A"
              />
              <path
                d="M7.486 18.447c0-3.924.773-7.663 2.173-11.08a14.48 14.48 0 00-3.622-2.28 18.232 18.232 0 00-4.364 6.216 7.285 7.285 0 015.813 7.144m0 0a7.287 7.287 0 01-5.813 7.143 18.249 18.249 0 004.364 6.216 14.535 14.535 0 003.622-2.282 29.153 29.153 0 01-2.173-11.077"
                fill="#933D86"
              />
              <path
                d="M9.659 29.524a14.56 14.56 0 005.091-11.077c0-4.437-1.976-8.407-5.091-11.08a29.16 29.16 0 00-2.173 11.08c0 3.92.773 7.661 2.173 11.077"
                fill="#AE3572"
              />
              <path
                d="M7.486 18.447a7.285 7.285 0 00-5.813-7.144 18.203 18.203 0 00-1.451 7.144c0 2.534.518 4.95 1.451 7.143a7.287 7.287 0 005.813-7.143"
                fill="#812C7C"
              />
              <path
                d="M52.621 16.82h-4.514v7.687h-2.109v-9.654h8.732v9.654h-2.109v-7.686zm4.458 7.687v-9.654h2.11v6.294l5.106-6.294h1.831v9.654h-2.109v-6.275l-5.106 6.275h-1.832zm11.396-9.654h2.11v3.917l4.162-3.917h2.757l-4.682 4.363 4.848 5.291h-2.701l-3.681-3.973-.704.687v3.286h-2.11v-9.654zm16.04 6.61v-.929c-.39-.13-1.074-.26-1.758-.26-1.517 0-2.536.316-2.536 1.28 0 .762.704 1.227 1.777 1.227 1.278 0 2.091-.669 2.517-1.319zM78.65 16.06c.906-.892 2.46-1.43 4.033-1.43 2.535 0 3.94 1.448 3.94 3.973v5.904h-2.108V23.45c-.574.631-1.555 1.17-2.98 1.17-2.109 0-3.496-1.189-3.496-3.045 0-2.154 1.942-3.064 4.496-3.064.685 0 1.536.112 1.98.26.017-1.392-.519-2.172-2.073-2.172-1.055 0-1.831.315-2.757 1.021l-1.035-1.56zm19.11 6.238c-.795 1.56-2.46 2.376-4.126 2.376-3.09 0-5.18-1.968-5.18-5.012 0-2.86 2.035-5.032 5.07-5.032 1.978 0 3.496.91 4.125 2.19l-1.573 1.04c-.647-.872-1.368-1.262-2.46-1.262-1.74 0-2.98 1.244-2.98 3.064 0 1.745 1.259 3.044 3.201 3.044 1.092 0 1.888-.557 2.424-1.373l1.499.965zm9.805 0c-.796 1.56-2.461 2.376-4.127 2.376-3.089 0-5.18-1.968-5.18-5.012 0-2.86 2.036-5.032 5.07-5.032 1.98 0 3.497.91 4.125 2.19l-1.572 1.04c-.648-.872-1.368-1.262-2.46-1.262-1.74 0-2.98 1.244-2.98 3.064 0 1.745 1.26 3.044 3.202 3.044 1.09 0 1.886-.557 2.422-1.373l1.5.965zm5.642.408c1.757 0 2.979-1.188 2.979-3.044 0-1.876-1.315-3.064-2.98-3.064-1.683 0-2.96 1.17-2.96 3.064 0 1.745 1.203 3.044 2.96 3.044zm0-8.076c3.034 0 5.161 2.117 5.161 5.032 0 2.896-2.127 5.012-5.161 5.012-2.998 0-5.144-2.116-5.144-5.012 0-2.915 2.09-5.032 5.144-5.032z"
                fill="#1A1919"
              />
            </g>
          </svg>
        </NavLink>
        <NavLink to={PAGE_TASK} className={styles.header_nav__link}>
          Задание
        </NavLink>
      </nav>
    </header>
  );
}
